<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path
      d="M8.88883 5.05469H6.5555C6.14294 5.05469 5.74728 5.21858 5.45556 5.5103C5.16383 5.80202 4.99995 6.19768 4.99995 6.61024V8.94358M18.9999 8.94358V6.61024C18.9999 6.19768 18.8361 5.80202 18.5443 5.5103C18.2526 5.21858 17.8569 5.05469 17.4444 5.05469H15.1111M15.1111 19.0547H17.4444C17.8569 19.0547 18.2526 18.8908 18.5443 18.5991C18.8361 18.3074 18.9999 17.9117 18.9999 17.4991V15.1658M4.99995 15.1658V17.4991C4.99995 17.9117 5.16383 18.3074 5.45556 18.5991C5.74728 18.8908 6.14294 19.0547 6.5555 19.0547H8.88883M4.22217 12.0547H19.7777"
      stroke="currentColor"
      stroke-width="1.38889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.13867 7.97222C7.13867 7.43528 7.57395 7 8.11089 7H15.8887C16.4256 7 16.8609 7.43528 16.8609 7.97222V11.8611H7.13867V7.97222Z"
      fill="currentColor"
    />
    <path
      d="M7.13867 15.7485C7.13867 16.2854 7.57395 16.7207 8.11089 16.7207H15.8887C16.4256 16.7207 16.8609 16.2854 16.8609 15.7485V13.804H7.13867V15.7485Z"
      fill="currentColor"
    />
  </svg>
</template>
